import { gql } from '@apollo/client';

export const createCommentMutation = gql`
  mutation createCommentMutation($data: CommentCreateInput!) {
    createComment(data: $data) {
      id
    }
  }
`;
